/**
 * Shopify CDN supports image resizing via `width` / `height` query params.
 * Adding them converts a full-resolution source (often 1500-2000px wide) into
 * a right-sized asset before it hits the wire, which matters on slow mobile
 * connections where a product thumbnail page otherwise ships multiple MB of
 * images that are rendered at ~64px.
 */
export function withShopifyImageSize(
  url: string | null | undefined,
  { width, height }: { width: number; height?: number },
): string | null | undefined {
  if (!url) {
    return url;
  }
  let parsed: URL;
  try {
    parsed = new URL(url);
  } catch {
    return url;
  }
  if (parsed.hostname !== "cdn.shopify.com") {
    return url;
  }
  parsed.searchParams.set("width", String(width));
  if (height !== undefined) {
    parsed.searchParams.set("height", String(height));
  }
  return parsed.toString();
}
